import { useHistory } from 'react-router-dom';
import React from 'react';
import Button from '@mui/material/Button';

const TrainingBack: React.FC = () => {
  const history = useHistory();
  const goBack = () => {
    history.goBack();
  };
  return (
    <section >
      <Button className='training-back' onClick={goBack}>
        <div className='training-back'>
          &lt; Back
        </div>
      </Button>
    </section>
  );
};
export default TrainingBack;
